export default __webpack_public_path__ + "static/media/5.71b33dea.png";